import {
  Button,
  Grid,
  InputAdornment,
  TextField,
  useTheme,
} from '@material-ui/core'
import React, { useState } from 'react'
import { MdEmail } from 'react-icons/md'
import { alterarUsuario, redefinirSenha } from '../../components/api'
import PasswordField from '../../components/PasswordField/PasswordField.js'
import { setInfo } from '../../components/alerts'

const RedefinirSenha = ({ voltarTelaLogin }) => {
  const theme = useTheme()

  const [passo, setPasso] = useState('email')

  const [usuario, setUsuario] = useState('')
  const [codigoEmail, setCodigoEmail] = useState('')
  const [senha, setSenha] = useState('')

  const redefinir = async () => {
    const res = await redefinirSenha(usuario)
    if (res.status) setPasso('codigoEmail')
  }

  const handleUsuario = (e) => setUsuario(e.target.value)
  const handleCodigoEmail = (e) => setCodigoEmail(e.target.value)
  const handleSenha = (e) => setSenha(e.target.value)

  const alterarSenha = async () => {
    const res = await alterarUsuario({
      tpTransacao: 'R',
      senhaAtual: codigoEmail,
      senhaNova: senha,
    })
    if (res.efetuarNovoLogin) {
      setInfo(res.dsMensagem)
      voltarTelaLogin()
    }
  }

  switch (passo) {
    case 'email':
      return (
        <>
          <Grid item xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              margin="dense"
              label="Email"
              value={usuario}
              onChange={handleUsuario}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <MdEmail fontSize={24} fill={theme.palette.action.active} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <button
              className="w-full rounded-md bg-default p-2 text-xl  font-sans  text-white transition-opacity hover:opacity-80"
              onClick={redefinir}
            >
              Recuperar senha
            </button>
          </Grid>
        </>
      )
    case 'codigoEmail':
      return (
        <>
          <Grid item xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              margin="dense"
              label="Código recebido no email"
              value={codigoEmail}
              onChange={handleCodigoEmail}
            />
          </Grid>
          <Grid item xs={12}>
            <PasswordField
              fullWidth
              variant="outlined"
              margin="dense"
              label="Nova senha"
              value={senha}
              onChange={handleSenha}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={alterarSenha}
            >
              Avançar
            </Button>
          </Grid>
        </>
      )
    default:
      return null
  }
}

export default RedefinirSenha
